let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("2Cftu"), load("4i0CB"), load("FBIp4")]).then(() => parcelRequire('cHhL0'));